import { useIntl } from 'react-intl'

const DiagramPreviewBody = ({ previewUrl, onLoad = () => {} }) => {
  const intl = useIntl()
  return (
    <iframe
      src={previewUrl}
      data-testid="fd-preview-iframe"
      style={{ height: '83vh', width: '100%' }}
      title={intl.formatMessage({ id: 'functionalDiagram.functionalDiagramPreview' })}
      onLoad={onLoad}
    />
  )
}

export default DiagramPreviewBody
